/* unplugin-vue-components disabled */import { render } from "./EmployeeTable.vue?vue&type=template&id=125314bc&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"

import "./EmployeeTable.vue?vue&type=style&index=0&id=125314bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125314bc"]])

export default __exports__